import React from 'react';
import { FormattedMessage } from 'react-intl';

import { RecalculationMAndRIcon, RoundArrowIcon } from '../../../icons.svg';

import { RTService } from '../../RideTwister.service';

const RideTwisterRecalculation = (props) => {
  const { recalculate, loading, activeSetting } = props;

  const { isActiveSetting } = RTService;

  const geArrowClass = () => (!loading ? 'roundArrow' : 'roundArrow loading');

  const getRecalcClass = () =>
    isActiveSetting(activeSetting)
      ? 'rtRecalculation active'
      : 'rtRecalculation';

  const getFill = () => (isActiveSetting(activeSetting) ? '#fff' : '#131313');

  return (
    <div className="rtRecalculationLayout">
      <span className="rtRecalculationTitle">
        <FormattedMessage id="Recalculate" defaultMessage="Recalculate" />
      </span>
      <div
        className={getRecalcClass()}
        onClick={(e) => recalculate(e)}
        aria-hidden
      >
        <RecalculationMAndRIcon width={26} height={26} fill={getFill()} />
        <RoundArrowIcon className={geArrowClass()} width={52} height={52} />
      </div>
    </div>
  );
};

export default RideTwisterRecalculation;
